import { ActivatedRoute } from '@angular/router';
var InvestigateComponent = /** @class */ (function () {
    function InvestigateComponent(Route) {
        var _this = this;
        this.Route = Route;
        this.Route.queryParams.subscribe(function (Params) {
            _this.Action = Params["a"];
        });
    }
    InvestigateComponent.prototype.ngOnInit = function () {
        $("#title").html(this.Action == "1" ? "ขอตรวจสอบ" : "อุทธรณ์");
    };
    return InvestigateComponent;
}());
export { InvestigateComponent };



// WEBPACK FOOTER //
// ./src/app/investigate/investigate.component.ts.pre-build-optimizer.js